/* カスタムスライダー: 無限ループ＋自動スクロール＋ドラッグ */
class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.js-slider');
    this.prevBtn = this.querySelector('[name="previous"]');
    this.nextBtn = this.querySelector('[name="next"]');
    if (!this.slider) return;
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = parseInt(this.dataset.speed || '3', 10) * 1000;
    this.timer = null;
    this.isDragging = false;
    this.dragMoved = false;
    this.startX = 0;
    this.scrollStart = 0;
    this.slides = Array.from(this.slider.querySelectorAll('.js-slide'));
    this.init();
  }

  init() {
    this.setupLoop();
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scroll(-1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scroll(1));
    if (this.autoplay) this.startAutoplay();
    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => { if (this.autoplay) this.startAutoplay(); });
    this.initDrag();
  }

  setupLoop() {
    if (this.slides.length < 2) return;
    // 末尾にクローンを追加
    this.slides.forEach(s => {
      const clone = s.cloneNode(true);
      clone.removeAttribute('id');
      clone.classList.add('js-slide--clone');
      this.slider.appendChild(clone);
    });
    // 先頭にクローンを追加（順序を保つためfragment使用）
    const fragment = document.createDocumentFragment();
    this.slides.forEach(s => {
      const clone = s.cloneNode(true);
      clone.removeAttribute('id');
      clone.classList.add('js-slide--clone');
      fragment.appendChild(clone);
    });
    this.slider.insertBefore(fragment, this.slider.firstChild);
    // 元のスライド群の先頭にスクロール
    requestAnimationFrame(() => {
      const gap = parseFloat(getComputedStyle(this.slider).gap) || 0;
      const slideW = this.slides[0].offsetWidth + gap;
      this.slider.style.scrollBehavior = 'auto';
      this.slider.scrollLeft = slideW * this.slides.length;
      this.slider.style.scrollBehavior = 'smooth';
      this.originLeft = this.slider.scrollLeft;
      this.checkLoop();
    });
  }

  checkLoop() {
    let ticking = false;
    this.slider.addEventListener('scroll', () => {
      if (ticking || this.isDragging) return;
      ticking = true;
      requestAnimationFrame(() => {
        this.resetIfNeeded();
        ticking = false;
      });
    });
  }

  resetIfNeeded() {
    const gap = parseFloat(getComputedStyle(this.slider).gap) || 0;
    const slideW = this.slides[0].offsetWidth + gap;
    const setWidth = slideW * this.slides.length;
    const scrollLeft = this.slider.scrollLeft;

    if (scrollLeft >= setWidth * 2 - 2) {
      this.slider.style.scrollBehavior = 'auto';
      this.slider.scrollLeft = scrollLeft - setWidth;
      this.slider.style.scrollBehavior = 'smooth';
    } else if (scrollLeft <= 2) {
      this.slider.style.scrollBehavior = 'auto';
      this.slider.scrollLeft = scrollLeft + setWidth;
      this.slider.style.scrollBehavior = 'smooth';
    }
  }

  initDrag() {
    const s = this.slider;
    s.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      this.isDragging = true;
      this.dragMoved = false;
      this.startX = e.pageX;
      this.scrollStart = s.scrollLeft;
      s.classList.add('is-dragging');
      this.stopAutoplay();
      e.preventDefault();
    });
    window.addEventListener('mousemove', (e) => {
      if (!this.isDragging) return;
      const dx = e.pageX - this.startX;
      if (Math.abs(dx) > 3) this.dragMoved = true;
      s.scrollLeft = this.scrollStart - dx;
    });
    const endDrag = () => {
      if (!this.isDragging) return;
      this.isDragging = false;
      s.classList.remove('is-dragging');
      this.resetIfNeeded();
      if (this.autoplay) this.startAutoplay();
    };
    window.addEventListener('mouseup', endDrag);
    s.addEventListener('click', (e) => {
      if (this.dragMoved) e.preventDefault();
    }, true);
  }

  scroll(dir) {
    const slide = this.slides[0];
    if (!slide) return;
    const gap = parseFloat(getComputedStyle(this.slider).gap) || 0;
    const amount = (slide.offsetWidth + gap) * dir;
    this.slider.scrollBy({ left: amount, behavior: 'smooth' });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => this.scroll(1), this.speed);
  }

  stopAutoplay() {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  }
}
customElements.define('custom-slider', CustomSlider);
